import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPharmacyNotesNew } from '../../../../../redux/notes/getNotesReducer';
import { getPharmacy } from '../../../../../redux/pharmacy';
import PharmacyInfo from '../PharmacyInfo';
import { ModalContext } from '../PharmacyModalContent';

const PharmacyInfoContainer = () => {
  const { notes, isFetching: areNotesFetching } = useSelector(
    (state) => state.notes,
  );
  const { pharmacy, isLoading: isPharmacyFetching } = useSelector(
    (state) => state.pharmacy,
  );
  const { pharmacyId } = React.useContext(ModalContext);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPharmacyNotesNew(pharmacyId));
    dispatch(getPharmacy(pharmacyId));
  }, [dispatch, pharmacyId]);

  return (
    <PharmacyInfo
      pharmacy={pharmacy}
      notes={notes}
      isLoading={areNotesFetching || isPharmacyFetching}
    />
  );
};

export default PharmacyInfoContainer;
